import {
  CHANGE_SELECTED_APPLICATION_TAB,
  REMOVE_APPLICATION_TAB,
  UPDATE_TABS,
  UPDATE_TAB_LOADING_STATUS_SUCCESS,
  RENAME_ITEM_SUCCESS,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    selectedTabId: undefined,
    list: [],
  };
};

const initialState = getInitialState();

const tabs = (state = initialState, action) => {
  const types = {
    [CHANGE_SELECTED_APPLICATION_TAB]: () => ({
      ...state,
      selectedTabId: action.id,
    }),
    [REMOVE_APPLICATION_TAB]: () => ({
      ...state,
    }),
    [UPDATE_TABS]: () => ({
      ...state,
      selectedTabId: action.newSelectedTabId,
      list: action.tabs,
    }),
    [UPDATE_TAB_LOADING_STATUS_SUCCESS]: () => ({
      ...state,
      list: action.tabs,
    }),
    [RENAME_ITEM_SUCCESS]: () => ({
      ...state,
      list: state.list.map(tab => {
        if (tab.audience.id === action.data.id) {
          return {
            ...tab,
            audience: { ...tab.audience, label: action.data.newLabel },
          };
        } else return tab;
      }),
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default tabs;
